export default "__VITE_PUBLIC_ASSET__c4aa741a__"